export default __webpack_public_path__ + "static/media/KatjaLovelace.ab045ff9.png";